import React, { useState } from "react";
import { FlexRow } from "appStyles";
import { Input, Container } from "vComponents";

function Billing({ style, passStateToParent, ...props }) {
  const [billingInfo, updateBillingInfo] = useState({
    first_name: "",
    last_name: "",
    address_city: "",
    address_line1: "",
    address_line2: "",
    address_state: "",
    address_zip: "",
  });
  const update = (e) => {
    const key = e.currentTarget.name;
    const value = e.currentTarget.value;
    updateBillingInfo({
      ...billingInfo,
      [key]: value,
    });

    const { first_name, last_name, ...addressPayload } = {
      ...billingInfo,
      [key]: value,
    };

    const payload = {
      name: `${first_name} ${last_name}`,
      ...addressPayload,
    };

    passStateToParent(payload);
  };

  return (
    <Container style={style}>
      <h3>Billing Information</h3>
      <FlexRow style={{ height: "auto" }}>
        <Input name="first_name" placeholder="FIRST NAME" onChange={update} />
        <Input name="last_name" placeholder="LAST NAME" onChange={update} />
      </FlexRow>
      <Input
        name="address_line1"
        placeholder="ADDRESS LINE 1"
        onChange={update}
      />
      <Input
        name="address_line2"
        placeholder="ADDRESS LINE 2"
        onChange={update}
      />
      <FlexRow style={{ height: "auto" }}>
        <Input name="address_city" placeholder="CITY" onChange={update} />
        <Input name="address_state" placeholder="STATE" onChange={update} />
        <Input name="address_zip" placeholder="ZIP" onChange={update} />
      </FlexRow>
    </Container>
  );
}

export default Billing;
